import { create } from 'zustand';
import { instituteApi } from '../api/institute.api';
import type { InstituteBranding } from '@/types/institute';

interface BrandingState {
  branding: InstituteBranding | null;
  /**
   * Bumped on every reload so `SecureImage` refetches instead of showing the
   * logo that was just replaced.
   */
  version: number;
  load: () => Promise<void>;
  clear: () => void;
}

/**
 * The signed-in user's own institute name and logo.
 *
 * Lives in a store rather than in the layout's own state because two places
 * need it at once: the sidebar draws it, and the profile screen changes it. A
 * store means uploading a new logo updates the sidebar immediately instead of
 * after a page reload.
 */
export const useInstituteBranding = create<BrandingState>((set, get) => ({
  branding: null,
  version: 0,

  load: async () => {
    try {
      const branding = await instituteApi.getBranding();
      set({ branding, version: get().version + 1 });
    } catch {
      // The sidebar falls back to the product name — a branding request that
      // fails must never keep someone out of their own institute.
    }
  },

  clear: () => set({ branding: null, version: 0 }),
}));
